/**
 * LOCAL DRUG-DRUG INTERACTIONS DATABASE
 * Comprehensive list of critical and serious interactions for rapid, offline checking.
 */

export interface SeriousDrugInteraction {
  drugA: string;
  drugB: string;
  severity: "SERIOUS" | "CRITICAL";
  mechanism: string;
  action: string;
}

export const SERIOUS_DRUG_INTERACTIONS: SeriousDrugInteraction[] = [
  {
    "drugA": "warfarin",
    "drugB": "aspirin",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "celecoxib",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "ketoprofen",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "meloxicam",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "piroxicam",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "clopidogrel",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "heparin",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "enoxaparin",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "rivaroxaban",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "apixaban",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "dabigatran",
    "severity": "SERIOUS",
    "mechanism": "Concomitant use increases susceptibility to gastrointestinal bleed and systemic hemorrhage.",
    "action": "Monitor INR closely. Avoid NSAIDs or antiplatelets if possible; use acetaminophen for pain."
  },
  {
    "drugA": "warfarin",
    "drugB": "clarithromycin",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "erythromycin",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "fluconazole",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "ketoconazole",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "itraconazole",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "voriconazole",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "amiodarone",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "ciprofloxacin",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "metronidazole",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "warfarin",
    "drugB": "cotrimoxazole",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP450 metabolism of warfarin, leading to significantly elevated INR and bleeding risk.",
    "action": "Monitor INR immediately upon initiation and adjust warfarin dose."
  },
  {
    "drugA": "simvastatin",
    "drugB": "clarithromycin",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "simvastatin",
    "drugB": "erythromycin",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "simvastatin",
    "drugB": "itraconazole",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "simvastatin",
    "drugB": "ketoconazole",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "simvastatin",
    "drugB": "ritonavir",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "simvastatin",
    "drugB": "diltiazem",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "simvastatin",
    "drugB": "verapamil",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "simvastatin",
    "drugB": "grapefruit juice",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "simvastatin",
    "drugB": "paxlovid",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases simvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "clarithromycin",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "erythromycin",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "itraconazole",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "ketoconazole",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "ritonavir",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "diltiazem",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "verapamil",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "grapefruit juice",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "atorvastatin",
    "drugB": "paxlovid",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases atorvastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "clarithromycin",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "erythromycin",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "itraconazole",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "ketoconazole",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "ritonavir",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "diltiazem",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "verapamil",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "grapefruit juice",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "lovastatin",
    "drugB": "paxlovid",
    "severity": "SERIOUS",
    "mechanism": "Significant CYP3A4 inhibition increases lovastatin levels, drastically increasing risk of myopathy and rhabdomyolysis.",
    "action": "Avoid combination or suspend statin therapy during treatment with inhibitor."
  },
  {
    "drugA": "sildenafil",
    "drugB": "isosorbide",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "sildenafil",
    "drugB": "nitroglycerin",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "sildenafil",
    "drugB": "glyceryl trinitrate",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "sildenafil",
    "drugB": "amyl nitrite",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "tadalafil",
    "drugB": "isosorbide",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "tadalafil",
    "drugB": "nitroglycerin",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "tadalafil",
    "drugB": "glyceryl trinitrate",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "tadalafil",
    "drugB": "amyl nitrite",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "vardenafil",
    "drugB": "isosorbide",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "vardenafil",
    "drugB": "nitroglycerin",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "vardenafil",
    "drugB": "glyceryl trinitrate",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "vardenafil",
    "drugB": "amyl nitrite",
    "severity": "CRITICAL",
    "mechanism": "Co-administration causes massive synergistic vasodilation resulting in profound, potentially fatal hypotension.",
    "action": "ABSOLUTELY CONTRAINDICATED. Do not prescribe together under any circumstances."
  },
  {
    "drugA": "ramipril",
    "drugB": "spironolactone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "ramipril",
    "drugB": "eplerenone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "ramipril",
    "drugB": "amiloride",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "ramipril",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "ramipril",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "ramipril",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "ramipril",
    "drugB": "celecoxib",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "lisinopril",
    "drugB": "spironolactone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "lisinopril",
    "drugB": "eplerenone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "lisinopril",
    "drugB": "amiloride",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "lisinopril",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "lisinopril",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "lisinopril",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "lisinopril",
    "drugB": "celecoxib",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "enalapril",
    "drugB": "spironolactone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "enalapril",
    "drugB": "eplerenone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "enalapril",
    "drugB": "amiloride",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "enalapril",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "enalapril",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "enalapril",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "enalapril",
    "drugB": "celecoxib",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "captopril",
    "drugB": "spironolactone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "captopril",
    "drugB": "eplerenone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "captopril",
    "drugB": "amiloride",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "captopril",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "captopril",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "captopril",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "captopril",
    "drugB": "celecoxib",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "losartan",
    "drugB": "spironolactone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "losartan",
    "drugB": "eplerenone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "losartan",
    "drugB": "amiloride",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "losartan",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "losartan",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "losartan",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "losartan",
    "drugB": "celecoxib",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "valsartan",
    "drugB": "spironolactone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "valsartan",
    "drugB": "eplerenone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "valsartan",
    "drugB": "amiloride",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "valsartan",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "valsartan",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "valsartan",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "valsartan",
    "drugB": "celecoxib",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "candesartan",
    "drugB": "spironolactone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "candesartan",
    "drugB": "eplerenone",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "candesartan",
    "drugB": "amiloride",
    "severity": "SERIOUS",
    "mechanism": "Synergistic potassium retention leading to severe, potentially fatal hyperkalemia and arrhythmias.",
    "action": "Monitor serum potassium and renal function closely. Adjust doses."
  },
  {
    "drugA": "candesartan",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "candesartan",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "candesartan",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "candesartan",
    "drugB": "celecoxib",
    "severity": "SERIOUS",
    "mechanism": "NSAIDs constrict afferent arteriole; ACEi/ARBs dilate efferent arteriole. Combination severely reduces GFR leading to acute kidney injury.",
    "action": "Avoid combination if possible. Monitor renal function."
  },
  {
    "drugA": "fluoxetine",
    "drugB": "tramadol",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "fluoxetine",
    "drugB": "fentanyl",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "fluoxetine",
    "drugB": "linezolid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "fluoxetine",
    "drugB": "methylene blue",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "fluoxetine",
    "drugB": "st johns wort",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "fluoxetine",
    "drugB": "selegiline",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "fluoxetine",
    "drugB": "phenelzine",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "fluoxetine",
    "drugB": "isocarboxazid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "sertraline",
    "drugB": "tramadol",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "sertraline",
    "drugB": "fentanyl",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "sertraline",
    "drugB": "linezolid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "sertraline",
    "drugB": "methylene blue",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "sertraline",
    "drugB": "st johns wort",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "sertraline",
    "drugB": "selegiline",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "sertraline",
    "drugB": "phenelzine",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "sertraline",
    "drugB": "isocarboxazid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "citalopram",
    "drugB": "tramadol",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "citalopram",
    "drugB": "fentanyl",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "citalopram",
    "drugB": "linezolid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "citalopram",
    "drugB": "methylene blue",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "citalopram",
    "drugB": "st johns wort",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "citalopram",
    "drugB": "selegiline",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "citalopram",
    "drugB": "phenelzine",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "citalopram",
    "drugB": "isocarboxazid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "escitalopram",
    "drugB": "tramadol",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "escitalopram",
    "drugB": "fentanyl",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "escitalopram",
    "drugB": "linezolid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "escitalopram",
    "drugB": "methylene blue",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "escitalopram",
    "drugB": "st johns wort",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "escitalopram",
    "drugB": "selegiline",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "escitalopram",
    "drugB": "phenelzine",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "escitalopram",
    "drugB": "isocarboxazid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "paroxetine",
    "drugB": "tramadol",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "paroxetine",
    "drugB": "fentanyl",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "paroxetine",
    "drugB": "linezolid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "paroxetine",
    "drugB": "methylene blue",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "paroxetine",
    "drugB": "st johns wort",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "paroxetine",
    "drugB": "selegiline",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "paroxetine",
    "drugB": "phenelzine",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "paroxetine",
    "drugB": "isocarboxazid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "venlafaxine",
    "drugB": "tramadol",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "venlafaxine",
    "drugB": "fentanyl",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "venlafaxine",
    "drugB": "linezolid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "venlafaxine",
    "drugB": "methylene blue",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "venlafaxine",
    "drugB": "st johns wort",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "venlafaxine",
    "drugB": "selegiline",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "venlafaxine",
    "drugB": "phenelzine",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "venlafaxine",
    "drugB": "isocarboxazid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "duloxetine",
    "drugB": "tramadol",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "duloxetine",
    "drugB": "fentanyl",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "duloxetine",
    "drugB": "linezolid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "duloxetine",
    "drugB": "methylene blue",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "duloxetine",
    "drugB": "st johns wort",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "duloxetine",
    "drugB": "selegiline",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "duloxetine",
    "drugB": "phenelzine",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "duloxetine",
    "drugB": "isocarboxazid",
    "severity": "CRITICAL",
    "mechanism": "Additive serotonergic effects leading to life-threatening Serotonin Syndrome.",
    "action": "Contraindicated. Require washout period before switching."
  },
  {
    "drugA": "amiodarone",
    "drugB": "sotalol",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "amiodarone",
    "drugB": "clarithromycin",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "amiodarone",
    "drugB": "erythromycin",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "amiodarone",
    "drugB": "haloperidol",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "amiodarone",
    "drugB": "quetiapine",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "amiodarone",
    "drugB": "ondansetron",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "amiodarone",
    "drugB": "citalopram",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "amiodarone",
    "drugB": "methadone",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "sotalol",
    "drugB": "clarithromycin",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "sotalol",
    "drugB": "erythromycin",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "sotalol",
    "drugB": "haloperidol",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "sotalol",
    "drugB": "quetiapine",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "sotalol",
    "drugB": "ondansetron",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "sotalol",
    "drugB": "citalopram",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "sotalol",
    "drugB": "methadone",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "clarithromycin",
    "drugB": "erythromycin",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "clarithromycin",
    "drugB": "haloperidol",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "clarithromycin",
    "drugB": "quetiapine",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "clarithromycin",
    "drugB": "ondansetron",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "clarithromycin",
    "drugB": "citalopram",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "clarithromycin",
    "drugB": "methadone",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "erythromycin",
    "drugB": "haloperidol",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "erythromycin",
    "drugB": "quetiapine",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "erythromycin",
    "drugB": "ondansetron",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "erythromycin",
    "drugB": "citalopram",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "erythromycin",
    "drugB": "methadone",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "haloperidol",
    "drugB": "quetiapine",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "haloperidol",
    "drugB": "ondansetron",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "haloperidol",
    "drugB": "citalopram",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "haloperidol",
    "drugB": "methadone",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "quetiapine",
    "drugB": "ondansetron",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "quetiapine",
    "drugB": "citalopram",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "quetiapine",
    "drugB": "methadone",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "ondansetron",
    "drugB": "citalopram",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "ondansetron",
    "drugB": "methadone",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "citalopram",
    "drugB": "methadone",
    "severity": "SERIOUS",
    "mechanism": "Additive prolongation of the QT interval, increasing risk of Torsades de Pointes and sudden cardiac death.",
    "action": "Avoid combination. If mandatory, monitor ECG and electrolytes closely."
  },
  {
    "drugA": "lithium",
    "drugB": "ibuprofen",
    "severity": "SERIOUS",
    "mechanism": "Decreases renal clearance of lithium, leading to severe neurotoxicity and lithium poisoning.",
    "action": "Avoid combination. Use acetaminophen for pain. If unavoidable, monitor lithium levels closely."
  },
  {
    "drugA": "lithium",
    "drugB": "diclofenac",
    "severity": "SERIOUS",
    "mechanism": "Decreases renal clearance of lithium, leading to severe neurotoxicity and lithium poisoning.",
    "action": "Avoid combination. Use acetaminophen for pain. If unavoidable, monitor lithium levels closely."
  },
  {
    "drugA": "lithium",
    "drugB": "naproxen",
    "severity": "SERIOUS",
    "mechanism": "Decreases renal clearance of lithium, leading to severe neurotoxicity and lithium poisoning.",
    "action": "Avoid combination. Use acetaminophen for pain. If unavoidable, monitor lithium levels closely."
  },
  {
    "drugA": "lithium",
    "drugB": "hydrochlorothiazide",
    "severity": "SERIOUS",
    "mechanism": "Decreases renal clearance of lithium, leading to severe neurotoxicity and lithium poisoning.",
    "action": "Avoid combination. Use acetaminophen for pain. If unavoidable, monitor lithium levels closely."
  },
  {
    "drugA": "lithium",
    "drugB": "indapamide",
    "severity": "SERIOUS",
    "mechanism": "Decreases renal clearance of lithium, leading to severe neurotoxicity and lithium poisoning.",
    "action": "Avoid combination. Use acetaminophen for pain. If unavoidable, monitor lithium levels closely."
  },
  {
    "drugA": "lithium",
    "drugB": "ramipril",
    "severity": "SERIOUS",
    "mechanism": "Decreases renal clearance of lithium, leading to severe neurotoxicity and lithium poisoning.",
    "action": "Avoid combination. Use acetaminophen for pain. If unavoidable, monitor lithium levels closely."
  },
  {
    "drugA": "lithium",
    "drugB": "lisinopril",
    "severity": "SERIOUS",
    "mechanism": "Decreases renal clearance of lithium, leading to severe neurotoxicity and lithium poisoning.",
    "action": "Avoid combination. Use acetaminophen for pain. If unavoidable, monitor lithium levels closely."
  },
  {
    "drugA": "methotrexate",
    "drugB": "trimethoprim",
    "severity": "CRITICAL",
    "mechanism": "Additive antifolate effects or reduced renal clearance leading to severe pancytopenia and bone marrow failure.",
    "action": "Contraindicated. Fatalities reported. Avoid concurrent use."
  },
  {
    "drugA": "methotrexate",
    "drugB": "cotrimoxazole",
    "severity": "CRITICAL",
    "mechanism": "Additive antifolate effects or reduced renal clearance leading to severe pancytopenia and bone marrow failure.",
    "action": "Contraindicated. Fatalities reported. Avoid concurrent use."
  },
  {
    "drugA": "methotrexate",
    "drugB": "ibuprofen",
    "severity": "CRITICAL",
    "mechanism": "Additive antifolate effects or reduced renal clearance leading to severe pancytopenia and bone marrow failure.",
    "action": "Contraindicated. Fatalities reported. Avoid concurrent use."
  },
  {
    "drugA": "methotrexate",
    "drugB": "diclofenac",
    "severity": "CRITICAL",
    "mechanism": "Additive antifolate effects or reduced renal clearance leading to severe pancytopenia and bone marrow failure.",
    "action": "Contraindicated. Fatalities reported. Avoid concurrent use."
  },
  {
    "drugA": "methotrexate",
    "drugB": "naproxen",
    "severity": "CRITICAL",
    "mechanism": "Additive antifolate effects or reduced renal clearance leading to severe pancytopenia and bone marrow failure.",
    "action": "Contraindicated. Fatalities reported. Avoid concurrent use."
  },
  {
    "drugA": "isotretinoin",
    "drugB": "doxycycline",
    "severity": "CRITICAL",
    "mechanism": "Co-administration increases the risk of pseudotumor cerebri (benign intracranial hypertension).",
    "action": "Contraindicated. Discontinue tetracycline before starting isotretinoin."
  },
  {
    "drugA": "isotretinoin",
    "drugB": "minocycline",
    "severity": "CRITICAL",
    "mechanism": "Co-administration increases the risk of pseudotumor cerebri (benign intracranial hypertension).",
    "action": "Contraindicated. Discontinue tetracycline before starting isotretinoin."
  },
  {
    "drugA": "isotretinoin",
    "drugB": "tetracycline",
    "severity": "CRITICAL",
    "mechanism": "Co-administration increases the risk of pseudotumor cerebri (benign intracranial hypertension).",
    "action": "Contraindicated. Discontinue tetracycline before starting isotretinoin."
  },
  {
    "drugA": "valproic acid",
    "drugB": "meropenem",
    "severity": "SERIOUS",
    "mechanism": "Carbapenems rapidly and drastically reduce serum valproic acid levels, leading to loss of seizure control.",
    "action": "Avoid combination. Switch antibiotic if possible."
  },
  {
    "drugA": "sodium valproate",
    "drugB": "meropenem",
    "severity": "SERIOUS",
    "mechanism": "Carbapenems rapidly and drastically reduce serum valproic acid levels, leading to loss of seizure control.",
    "action": "Avoid combination. Switch antibiotic if possible."
  },
  {
    "drugA": "valproic acid",
    "drugB": "imipenem",
    "severity": "SERIOUS",
    "mechanism": "Carbapenems rapidly and drastically reduce serum valproic acid levels, leading to loss of seizure control.",
    "action": "Avoid combination. Switch antibiotic if possible."
  },
  {
    "drugA": "sodium valproate",
    "drugB": "imipenem",
    "severity": "SERIOUS",
    "mechanism": "Carbapenems rapidly and drastically reduce serum valproic acid levels, leading to loss of seizure control.",
    "action": "Avoid combination. Switch antibiotic if possible."
  },
  {
    "drugA": "valproic acid",
    "drugB": "ertapenem",
    "severity": "SERIOUS",
    "mechanism": "Carbapenems rapidly and drastically reduce serum valproic acid levels, leading to loss of seizure control.",
    "action": "Avoid combination. Switch antibiotic if possible."
  },
  {
    "drugA": "sodium valproate",
    "drugB": "ertapenem",
    "severity": "SERIOUS",
    "mechanism": "Carbapenems rapidly and drastically reduce serum valproic acid levels, leading to loss of seizure control.",
    "action": "Avoid combination. Switch antibiotic if possible."
  },
  {
    "drugA": "clopidogrel",
    "drugB": "omeprazole",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP2C19 activation of clopidogrel, increasing risk of cardiovascular events and stent thrombosis.",
    "action": "Use pantoprazole or an H2 blocker instead, as they have less CYP2C19 inhibition."
  },
  {
    "drugA": "clopidogrel",
    "drugB": "esomeprazole",
    "severity": "SERIOUS",
    "mechanism": "Inhibits CYP2C19 activation of clopidogrel, increasing risk of cardiovascular events and stent thrombosis.",
    "action": "Use pantoprazole or an H2 blocker instead, as they have less CYP2C19 inhibition."
  }
,
  {
    "drugA": "methotrexate",
    "drugB": "itraconazole",
    "severity": "SERIOUS",
    "mechanism": "Itraconazole may decrease the renal clearance of methotrexate, leading to elevated methotrexate levels and increased risk of toxicity.",
    "action": "Monitor closely for methotrexate toxicity. Consider dose reduction of methotrexate if concurrent use is necessary."
  }
];
